import { ResponsivePie, Pie } from "@nivo/pie";
import { useNavigate } from "react-router-dom";
import React from "react";
import { useWindowSize } from "../../../global/hooks/viewportHooks";

export const PieChart = ({ compInfo }) => {
  const navigate = useNavigate();
  let tempWidth = useWindowSize();
  let width = tempWidth.width;

  function get_colors(compInfo) {
    let legend_labels = [];
    for (const data in compInfo) {
      legend_labels.push(compInfo[data].id);
    }

    return (
      legend_labels.includes("activated") ||
      legend_labels.includes("Fair") ||
      legend_labels.includes("Poor")
    );
  }

  const sensor_colors = {
    activated: "#03AC3F",
    Fair: "#FEBF3C",
    Poor: "#ED7000",
  };

  const gateway_colors = {
    Active: "#03AC3F",
    "ready pending": "#ED7000",
  };

  const chart_type = get_colors(compInfo);
  //if true it's a sensor pie chart, else gateway health
  const colors = chart_type ? sensor_colors : gateway_colors;
  const title = chart_type ? "Sensor Health" : "";

  // console.log("legend colors after function", colors);

  // This centers the text in pieChart
  const CenteredText = ({ centerX, centerY }) => {
    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontSize: "16px",
          fontWeight: 400,
        }}
      >
        {title}
      </text>
    );
  };

  return (
    <ResponsivePie
      theme={{
        legends: {
          text: { fontSize: "16" },
        },
      }}
      data={compInfo}
      padding={{ top: 80 }}
      colors={(d) => colors[d.id]}
      margin={
        width < 768
          ? { top: 40, right: 40, bottom: 40, left: 40 }
          : { top: 25, right: 20, bottom: 70, left: 20 }
      }
      innerRadius={width < 768 ? 0.7 : 0.85}
      label
      padAngle={0.7}
      activeOuterRadiusOffset={5}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      arcLinkLabelsSkipAngle={10}
      enableArcLinkLabels={width < 768 ? true : false}
      enableArcLabels={width < 768 ? true : false}
      arcLabelsRadiusOffset={0.4}
      arcLabelsSkipAngle={7}
      activeInnerRadiusOffset={5}
      layers={[
        "arcs",
        "arcLabels",
        "arcLinkLabels",
        "legends",
        width < 768 ? null : CenteredText,
      ]}
      arcLabelsTextColor={{
        from: "color",
      }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          size: 6,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      legends={
        width > 768
          ? [
              {
                anchor: "bottom-left",
                direction: "column",
                justify: false,
                translateY: 50,
                itemsSpacing: 2.5,
                itemWidth: 55,
                itemHeight: 15,
                itemTextColor: "black",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 10,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#000",
                    },
                  },
                ],
              },
            ]
          : ""
      }
      onClick={(data) => {
        let gatewayData = "";
        // console.log(data.data.component);
        gatewayData = data.data.component;
        // data.data.component.component.map((data) => {
        //     gatewayData = data;
        // });

        // console.log(gatewayData);

        let title = data.data.isGateway ? "Gateway List" : "Sensors List";
        navigate(`/gatewaylist`, {
          state: {
            data: gatewayData,
            title: title,
          },
        });
      }}
    />
  );
};
